import { sort, when } from 'ramda'

import { localeSort } from '@surglogs/util'

import { getName } from '../models/getters/clinic'

export const deriveClinicListSorted = when(
  Array.isArray,
  sort(localeSort(getName)),
)
